import stores from '~/common/stores/stores.js';

export default () => {
    const {
        Street1,
        City,
        ZipCode,
        StateCode,
        CountryCode
    } = stores.formsStore;
    const { offerSuiteStore, convertToPaidStore, lockNumberStore, promoCodeStore } = stores;

    const estObject = {
        ContactAddress: {
            Street1,
            City,
            ZipCode,
            StateCode,
            CountryCode
        },
        OfferSuiteId: offerSuiteStore.offerSuiteId,
        OfferName: offerSuiteStore.offerName,
        PromoCode: promoCodeStore.promoCodeName,
        PromoId: promoCodeStore.promoCodeId
    };

    if (!convertToPaidStore.isUserConvertingToPaid) {
        estObject.SubscriptionNumber = lockNumberStore.selectedNumberE164;
        estObject.OptInSMS = 'true';
    }
    // FIXME: remove afer pricing test is over PLANS C
    if (offerSuiteStore.usersPerAccount) estObject.UserCount = offerSuiteStore.usersPerAccount;

    return estObject;
};
